import { FunnelSimple } from "@phosphor-icons/react";

import {
  DropdownMenu,
  DropdownMenuCheckbox,
  DropdownMenuContent,
  DropdownMenuCount,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import FilterButton from "common/components/ui/FilterButton";

import { AUDIENCE_PROFILE_STATES } from "../../../constants";

import type { AudienceProfile, AudienceProfileState } from "../../../types";

interface FiltersPopoverProps {
  selectedStates: AudienceProfileState[];
  setSelectedStates: (selectedGroups: AudienceProfileState[]) => void;
  audience: AudienceProfile[];
}

export default function FiltersPopover({
  selectedStates,
  setSelectedStates,
  audience,
}: FiltersPopoverProps) {
  function addStateFilters(states: AudienceProfileState[]) {
    setSelectedStates([...selectedStates, ...states]);
  }
  function removeStateFilters(states: AudienceProfileState[]) {
    setSelectedStates(
      selectedStates.filter((state) => !states.includes(state)),
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <FilterButton leftIcon={<FunnelSimple />}>
          {selectedStates.length
            ? `${selectedStates.length} ${selectedStates.length === 1 ? "filter" : "filters"}`
            : "All audience"}
        </FilterButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuList>
          <DropdownMenuItem onSelect={() => setSelectedStates([])}>
            All audience
            {audience && (
              <DropdownMenuCount>{audience.length}</DropdownMenuCount>
            )}
          </DropdownMenuItem>
          {AUDIENCE_PROFILE_STATES.map(({ label, states }) => {
            const isChecked = selectedStates.some((selectedState) =>
              states.some((state) => selectedState === state),
            );
            return (
              <DropdownMenuItem
                key={label}
                onSelect={() => {
                  setSelectedStates(states);
                }}
              >
                <DropdownMenuCheckbox
                  isChecked={isChecked}
                  onCheckedChange={() => {
                    if (isChecked) {
                      removeStateFilters(states);
                    } else {
                      addStateFilters(states);
                    }
                  }}
                />
                {label}
                {audience && (
                  <DropdownMenuCount>
                    {
                      audience.filter(({ state }) => states.includes(state))
                        .length
                    }
                  </DropdownMenuCount>
                )}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuList>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
